<!--
 * @Author: 
 * @Date: 2022-07-22 23:28:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-22 23:54:42
 * @FilePath: /Cup2Supplier/Users/onepisya/Documents/GitHub/jdhl_work/Cup2Market/src/views/Home/goodsRecommendTab.vue
 * @Description: 
-->
<template>
  <div class="all-column-area">
    <div
      v-for="(row, index) in goodsSettingList"
      :key="index"
      class="good-column-area"
    >
      <TobBar :bgImg="row.mainImage">
        <template #center>
          <div class="center-text">
            {{ row.name }}
          </div>
        </template>

        <template #right v-if="row.cateId">
          <div
            class="right-text"
            @click="$emit('lookMoreGoodsCate', row.cateId)"
          >
            <span>查看更多</span>
            <van-icon name="arrow" />
          </div>
        </template>
      </TobBar>

      <keep-alive>
        <masonry-wall
          ref="masonryWall"
          :key="index"
          class="p-2"
          :items="row.goodsList"
          :column-width="171"
          :gap="10"
        >
          <template v-if="defer(5)" #default="{ item, index }">
            <GoodsCard
              lazy-load
              fit="fill"
              :key="index"
              :data="item"
            ></GoodsCard>
          </template>
        </masonry-wall>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import TobBar from "./components/TobBar";
import GoodsCard from "@/components/card/GoodsCard";
import Defer from "@/mixins/defer";
export default {
  name: "GoodsRecommendTab",
  components: { GoodsCard, TobBar },
  mixins: [Defer(60)],
  props: {
    goodsSettingList: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
.all-column-area {
  padding-bottom: 100px;
  .good-column-area {
    .center-text,
    .right-text {
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #ffffff;
    }

    .center-text {
      font-size: 36px;
      font-weight: 600;
      line-height: 96px;
      display: flex;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
    }

    .right-text {
      font-size: 20px;
      font-weight: 400;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      line-height: 96px;
    }
  }
}
</style>
